module.exports = __webpack_public_path__ + "img/progress_2.ed787761.png";